<template>
  <div class="column-1-2">
    <h4 class="footer-title">
      {{ typeText[type] }}
    </h4>
    <div
      class="row-start-1 row-start-2 row-start-3 
                    row-start-4 row-start-5 row-start-6 row-start-7 hidden"
    ></div>
    <ul class="ul-align-grid">
      <li
        v-for="(city, index) in footerInfo?.cities"
        :key="city.id"
        :class="
          index < 4 || index < 7 || index < 10
            ? `row-start-${rowFormatted(index)}`
            : ``
        "
      >
        <span class="cursor-pointer" @click="handleClick(city)">
          {{ formattedText(city.name) }}</span
        >
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useGeneral } from "@/composables/useGeneral";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { ROUTE_VALUES, DEFAULT_LANGUAGES } from "@/constants.js";
import { useRoute, useRouter } from "vue-router";
import { event } from "vue-gtag";

const { footerInfo } = useGeneral();
const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const languajes = ref(["es", "de", "en", "fr", "it", "pt"]);
const langIndex = ref(0);
const typeText = ref({
  concerts: t("general.footer.concertsIn"),
  festivals: t("general.footer.festivalsIn"),
  venues: t("general.footer.venuesIn")
});

const props = defineProps({
  type: {
    type: String,
    default: "concerts"
  }
});
const rowFormatted = index => {
  return (index % Math.ceil(footerInfo.value.cities.length / 3)) + 1;
};
const urlFormatter = (cityData = {}) => {
  let url = "/" + (route.params.region || "es") + "/";
  if (props.type === "festivals") {
    url += ROUTE_VALUES.festivalStrinigs[langIndex.value];
  } else if (props.type === "concerts") {
    url += ROUTE_VALUES.concertStrinigs[langIndex.value];
  } else {
    url += ROUTE_VALUES.venueStrinigs[langIndex.value];
  }
  url += "/geo/" + (footerInfo.value.country_slug || "espana");
  if (cityData.id) {
    url +=
      "/" +
      cityData.administrative_division.toLowerCase() +
      "/" +
      cityData.slug;
  }
  return url;
};
const handleClick = city => {
  event("footer_city", {
    event_category: "click",
    event_label: props.type,
    event_value: city.name
  });
  router.push(urlFormatter(city));
};
const formattedText = city => {
  if (city === "Santa Cruz de Tenerife") {
    city = "Tenerife";
  }
  if (props.type === "concerts") {
    return t("general.footer.concertsInCity", { city: city });
  } else if (props.type === "festivals") {
    return t("general.footer.festivalsInCity", { city: city });
  } else {
    return t("general.footer.venuesInCity", { city: city });
  }
};

onMounted(() => {
  let actualLang = DEFAULT_LANGUAGES[route.params.region || "es"];
  langIndex.value = languajes.value.findIndex(lang => lang === actualLang);
});
</script>

<style lang="scss" scoped>
h4 {
  margin-bottom: 7px;
  font-weight: 600;
}
.ul-align-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  li {
    color: $textosecundario;
    font-size: 13px;
  }
}
</style>
